<div
	class="sidepanel"
	role="navigation"
	[hidden]="!sidePanelVisible"
	[cdkTrapFocus]="shouldTrapFocusToSidepanel">
	<div
		class="side-panel-content"
		*ngIf="!sidePanelLoading">
		<div class="side-panel-header">
			<h2
				translate="library-collections"
				class="side-panel-title">
			</h2>
			<button
				type="button"
				*ngIf="collectionManagement"
				(click)="openManageCollectionsPanel()"
				class="btn btn-none manage-collections-btn"
				data-cy="manage-collections-btn"
				[matTooltip]="'library-collections_manage-collections' | translate">
				<i class="ficon-gear"></i>
			</button>
		</div>
		<ul class="side-panel-list">
			<li
				class="collection-list-item side-panel-list-item"
				data-cy="collection-list-item"
				*ngFor="let collection of visibleCollections"
				[ngClass]="{
					'active': collection.id === selectedCollection.id,
					'mineCollection': collection.type === libraryTypes.MINE,
					'orgCollection': collection.type === libraryTypes.ORG,
					'historyCollection': collection.type === libraryTypes.ARCHIVE,
					'legacyCollection': collection.type === libraryTypes.LEGACY,
					'managedCollection': collection.type === libraryTypes.MANAGED,
					'directShareCollection': collection.type === libraryTypes.DIRECT_SHARE
				}"
				tabindex="0"
				(click)="selectCollection(collection)"
				(keyup.enter)="selectCollection(collection)"
			>
				{{collection.name}}
			</li>
		</ul>
	</div>
	<div
		class="panel-loading"
		*ngIf="sidePanelLoading">
			<span class="ficon-spinner ficon-spin"></span>
			<span translate="library-viewer_loading"></span>
	</div>
</div>
<main class="main-panel" role="main">
	<div
		class="panel-overlay"
		*ngIf="showOverlay()"
		(click)="toggleSidePanel()">
	</div>
	<div
		class="main-panel-content"
		*ngIf="!mainPanelLoading">
		<div class="main-panel-header">
			<span class="left-header">
				<button
					type="button"
					class="btn btn-none toggle-side-panel-btn"
					(click)="toggleSidePanel()"
					[matTooltip]="'library-collections_show-navigation' | translate">
					<i class="ficon-menu"></i>
				</button>
				<h2 class="collection-title">{{selectedCollection.name + ': ' + selectedContentType.name}}</h2>
			</span>
			<mat-slide-toggle
				[hideIcon]="true"
				*ngIf="mode !== modes.SELECT"
				[(ngModel)]="multiSelect"
				(change)="toggleMultiSelect()"
				color="primary"
				class="multi-select-slide-toggle">
				{{ 'library-collections_multi-select' | translate }}
			</mat-slide-toggle>
		</div>
		<div class="main-panel-sub-header">
			<div class="filter-and-sort-container">
				<div class="filter-container">
					<mat-form-field goSelect>
						<mat-label>{{ 'common_filter-by' | translate }}</mat-label>
						<mat-select
							[(ngModel)]="selectedContentType"
							(selectionChange)="selectContentType($event.value)"
							disableOptionCentering
							data-cy="library-filter-menu"
							panelClass="offsetPanel">
							<mat-option
								class="filter-option"
								*ngFor="let type of contentTypes | sort:'sort_order'"
								[attr.data-cy]="'type-' + type.slug"
								[value]="type">
								{{ type.name }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>
				</div>
				<div class="sort-container">
					<mat-form-field goSelect>
						<mat-label>{{ 'common_sort-by' | translate }}</mat-label>
						<mat-select
							[(ngModel)]="sortBy"
							(ngModelChange)="updateTreeSort()"
							disableOptionCentering
							panelClass="offsetPanel">
							<mat-option
								class="sort-option"
								*ngFor="let option of sortOptions"
								[value]="option">
								{{ sortOrderTranslations[option] | translate }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>
				</div>
			</div>

			<div class="search-bar">
				<div class="input-group" role="search">
					<span class="search-txt" translate="common_search"></span>
					<input type="text"
						class="form-control search-input"
						data-cy="collection-items-search"
						[formControl]="searchStrForm"
						(blur)="onSearchBlur()"
						[attr.aria-label]="('library-viewer-item_search-label' | translate)">
					<span *ngIf="!searchStr" class="input-group-addon"><i class="ficon-search"></i></span>
					<span *ngIf="searchStr" class="input-group-addon search-clear">
						<button (click)="clearSearch()" [attr.aria-label]="('common_cancel-search' | translate)" class="ficon-app-x btn-none"></button>
					</span>
				</div>

				@if (useTreeView && searchError) {
					<div class="search-result-info" aria-live="polite">
						<span>{{ searchError | translate }}</span>
					</div>
				}

				<div aria-live="polite" class="search-result-info" *ngIf="searchStr">
					<span
						*ngIf="collectionItems.items.length > 0"
						data-cy="library-viewer-item_search-result-info"
						[innerHtml]="'library-viewer-item_search-result-info' | translate: {
							text: searchStr,
							count: getResultsCount(),
							total: collectionItems.items.length}
						">
					</span>
				</div>
			</div>
		</div>
		@if (getItemCount() > 0 || getFolderCount() > 0) {
			<div #collectionItemsListRef
				 class="collection-items-wrapper"
				 data-cy="collection-items-wrapper"
			>
				<div class="collection-item-header">
					<div class="leftside-header">
						<div
							class="checkbox"
							*ngIf="multiSelect && !searchStr">
							<mat-checkbox
								class="select-all"
								color="primary"
								[checked]="selectAllChecked"
								[(ngModel)]="selectAllChecked"
								(change)="selectAll()"
								[attr.aria-label]="'library-collections_multi-select-all' | translate"
							>
							</mat-checkbox>
						</div>
						<div
							class="collection-item-header-name"
							[ngClass]="{'withMargin': multiSelect}"
							translate="library-collections_header-name">
						</div>
					</div>
					<div class="rightside-header">
						<div
							class="collection-item-header-modified"
							[ngClass]="{'withMargin': !multiSelect}"
							translate="library-collections_header-modified">
						</div>

						<button
							*ngIf="multiSelect"
							type="button"
							[matMenuTriggerFor]="menu"
							class="menu-btn collection-item-menu item-options-dropdown-menu btn-none"
							data-cy="library-item-dropdown-menu"
							[attr.aria-label]="('collection-item-menu' | translate)"
							(click)="setActiveToggle($event)"
						>
							<i class="ficon-app-dots-vertical"></i>
						</button>
						<mat-menu #menu="matMenu">
							<button
								mat-menu-item
								type="button"
								class="copy-option"
								data-cy="common-copy"
								(click)="copyItems()">
								<span translate="common_copy"></span>
							</button>
							<button
								mat-menu-item
								type="button"
								class="move-option"
								data-cy="common-move"
								*ngIf="!hideOnArchiveAndManaged()"
								(click)="moveItems()">
								<span translate="common_move"></span>
							</button>
							<button
								mat-menu-item
								type="button"
								class="remove-option"
								data-cy="common-remove"
								*ngIf="!hideOnArchiveAndManaged()"
								(click)="removeItems()">
								<span translate="common_remove"></span>
							</button>
						</mat-menu>
					</div>
				</div>
				<div class="collection-items-list" *ngIf="!useTreeView">
					<ngx-collection-folder-viewer
						*ngFor="let folder of collectionItems.folders | sort:getSortKey(true)"
						[folder]="folder"
						[expanded]="expanded"
						[expandedFolders]="expandedFolders"
						[mode]="mode"
						[orgSettings]="orgSettings"
						(selectItem)="select($event)"
						[collections]="collections"
						[archiveCollection]="archiveCollection"
						[selectedCollection]="selectedCollection"
						[selectedContentType]="selectedContentType"
						(loadNewItems)="loadNewItems($event)"
						[collectionItems]="collectionItems"
						[sortBy]="sortBy"
						[searchStr]="searchStr"
						[multiSelect]="multiSelect"
						(setSelectAllChecked)="setSelectAllChecked($event)"
						[expandedHeight]="expandedHeight"
						[currentlySelected]="currentlySelected"
						(setActivityPanelIsOpen)="setActivityPanelIsOpen($event)"
						(setCurrentlySelected)="setCurrentlySelected($event)"
					></ngx-collection-folder-viewer>
					<ngx-collection-item-viewer
						class="collection-item"
						[ngClass]="{'active': expanded.includes(item.hash)}"
						*ngFor="let item of itemsWithoutFolder | search:searchStr:['name', 'description', 'creator_name'] | sort:getSortKey()"
						[item]="item"
						[expanded]="expanded"
						[mode]="mode"
						(selectItem)="select($event)"
						[collections]="collections"
						[orgSettings]="orgSettings"
						[archiveCollection]="archiveCollection"
						[selectedCollection]="selectedCollection"
						[selectedContentType]="selectedContentType"
						(loadNewItems)="loadNewItems($event)"
						[collectionItems]="collectionItems"
						[items]="itemsWithoutFolder"
						(updateItems)="updateItems()"
						[multiSelect]="multiSelect"
						(setSelectAllChecked)="setSelectAllChecked($event)"
						[expandedHeight]="expandedHeight"
						[currentlySelected]="currentlySelected"
						(setActivityPanelIsOpen)="setActivityPanelIsOpen($event)"
						(setCurrentlySelected)="setCurrentlySelected($event)"
					></ngx-collection-item-viewer>
				</div>
				<div class="collection-items-list" *ngIf="useTreeView">
					@if (getItemCount() > 0 || getFolderCount() > 0) {
						<ngx-library-tree-viewer
							[collectionItems]="collectionItems"
							[selectedCollection]="selectedCollection"
							[selectedContentType]="selectedContentType"
							[collections]="collections"
							[archiveCollection]="archiveCollection"
							[mode]="mode"
							[multiSelect]="multiSelect"
							[sortBy]="sortBy"
							[currentlySelected]="currentlySelected"
							[searchStr]="searchStr"
							[orgSettings]="orgSettings"
							(selectItem)="select($event)"
							(setCurrentlySelected)="setCurrentlySelected($event)"
							(loadNewItems)="loadNewItems($event)"
							(setActivityPanelIsOpen)="setActivityPanelIsOpen($event)">
						</ngx-library-tree-viewer>
					}
				</div>
			</div>
		}
		<div class="zero-state-wrapper" aria-live="assertive" aria-hidden="false">
			@if (shouldShowZeroState()) {
				<ngx-zero-state
					class="zero-state-items"
					[ngSwitch]="selectedContentType.slug">
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.ALL" translate="library-viewer-item_zero-state-all"></span>
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.MEDIA" translate="library-viewer-item_zero-state-media"></span>
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.RUBRICS" translate="library-viewer-item_zero-state-rubrics"></span>
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.MARKERS" translate="library-viewer-item_zero-state-markers"></span>
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.DOCUMENTS" translate="library-viewer-item_zero-state-documents"></span>
					<span zero-state-subtext *ngSwitchCase="CONTENT_TYPES.ACTIVITIES" translate="library-viewer-item_zero-state-activities"></span>
				</ngx-zero-state>
			}
		</div>
		<div *ngIf="collectionManagement" class="main-panel-footer">
			<button
				type="button"
				[ngClass]="{
					'tertiary-btn': mode === 'select',
					'primary-btn': mode !== 'select'
				}"
				class="close-btn goreact-btn"
				data-cy="lib-close-btn"
				(click)="cancel.emit()"
				translate="{{ mode === 'select' ? 'common_cancel'  : 'common_close' }}">
			</button>
			<span
				class="action-container"
				*ngIf="showActionContainer()">
				<button
					*ngIf="selectedContentType.slug !== CONTENT_TYPES.ALL"
					type="button"
					id="add-library-item-btn"
					[attr.data-cy]="'add-' + selectedContentType.slug"
					class="goreact-btn link-btn add-btn {{selectedContentType.slug}} add-{{selectedContentType.slug}}"
					(click)="addLibraryItem(selectedContentType)"
					[attr.aria-label]="('Add ' + selectedContentType.slug)">
						<span [ngSwitch]="selectedContentType.slug">
							<span *ngSwitchCase="CONTENT_TYPES.MEDIA" translate="library-collections_add-media"></span>
							<span *ngSwitchCase="CONTENT_TYPES.RUBRICS" translate="library-collections_add-rubric"></span>
							<span *ngSwitchCase="CONTENT_TYPES.MARKERS" translate="library-collections_add-markers"></span>
							<span *ngSwitchCase="CONTENT_TYPES.DOCUMENTS" translate="library-collections_add-document"></span>
							<span *ngSwitchCase="CONTENT_TYPES.ACTIVITIES" translate="library-collections_add-activity"></span>
						</span>
				</button>
				<button
					*ngIf="selectedContentType.slug === CONTENT_TYPES.ALL"
					type="button"
					[matMenuTriggerFor]="typeMenu"
					data-cy="add-all"
					class="goreact-btn link-btn add-btn {{selectedContentType.slug}} add-{{selectedContentType.slug}} new-content-menu mat-menu-trigger"
				>
					<span translate="library-collections_add-content"></span>
				</button>
				<mat-menu #typeMenu="matMenu">
					<button
						mat-menu-item
						type="button"
						[attr.data-cy]="'add-' + type.slug"
						(click)="addLibraryItem(type)"
						*ngFor="let type of contentTypesWithoutAll | sort:'sort_order'">
						<span [ngSwitch]="type.slug">
							<span *ngSwitchCase="CONTENT_TYPES.MEDIA" translate="library-collections_add-media"></span>
							<span *ngSwitchCase="CONTENT_TYPES.RUBRICS" translate="library-collections_add-rubric"></span>
							<span *ngSwitchCase="CONTENT_TYPES.MARKERS" translate="library-collections_add-markers"></span>
							<span *ngSwitchCase="CONTENT_TYPES.DOCUMENTS" translate="library-collections_add-document"></span>
							<span *ngSwitchCase="CONTENT_TYPES.ACTIVITIES" translate="library-collections_add-activity"></span>
						</span>
					</button>
				</mat-menu>
				<button
					type="button"
					data-cy="add-folder"
					class="link-btn add-btn add-folder-btn goreact-btn"
					[attr.aria-label]="('library-collections_add-folder-aria' | translate)"
					(click)="openAddFolderModal()">
					<span translate="library-collections_add-folder"></span>
				</button>
			</span>
		</div>
	</div>
	<!-- Only show one loading indicator at a time, so wait until side panel loads to show this (or if side panel isn't visible) -->
	<div
		class="panel-loading"
		*ngIf="(!sidePanelLoading && mainPanelLoading) || (!sidePanelVisible && mainPanelLoading)">
			<span class="ficon-spinner ficon-spin"></span>
			<span translate="library-viewer_loading"></span>
	</div>
</main>
@if (activityPanelIsOpen()) {
	<div class="library-overlay"></div>
}
